<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <!--      <template slot="menuLeft">-->
      <!--        <el-button-->
      <!--          type="danger"-->
      <!--          size="small"-->
      <!--          icon="el-icon-delete"-->
      <!--          plain-->
      <!--          v-if="permission.inspecttaskerror_delete"-->
      <!--          @click="handleDelete"-->
      <!--          >删 除-->
      <!--        </el-button>-->
      <!--      </template>-->
      <template slot="equipmentName" slot-scope="scope">
        <el-tag>{{
          scope.row.equipmentName == '通用巡检项' || scope.row.equipmentName == ''
            ? '无设备'
            : scope.row.equipmentName
        }}</el-tag>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/inspecttaskerror/inspecttaskerror';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        selection: false,
        columnBtn: false,
        menu: false,
        searchLabelWidth: 120,
        column: [
          {
            label: '主键',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入主键',
                trigger: 'change',
              },
            ],
            hide: true,
          },
          {
            label: '所属小区',
            prop: 'areaId',
            type: 'tree',
            dataType: 'string',
            dicUrl: 'api/base/property/treeChildrenPowerNode',
            props: { label: 'objectFullName', value: 'id' },
            search: true,
          },
          {
            label: '异常上报班组',
            prop: 'groupName',
            overHidden: true,
          },
          {
            label: '异常上报人',
            prop: 'userName',
          },
          {
            label: '班组id',
            prop: 'groupId',
            hide: true,
          },
          {
            label: '巡检点位',
            prop: 'nodeId',
            type: 'tree',
            dataType: 'string',
            dicUrl: 'api/inspectNode/inspectNodeTree',
            props: { label: 'nodeName', value: 'id' },
            overHidden: true,
          },
          {
            label: '巡检点位',
            prop: 'nodeName',
            hide: true,
            search: true,
            maxlength: 30,
            showWordLimit: true,
            searchPlaceholder: '模糊匹配巡检点位',
          },
          {
            label: '点位设备名',
            prop: 'equipmentName',
            overHidden: true,
            search: true,
            slot: true,
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '任务Id',
            prop: 'taskId',
            hide: true,
          },
          {
            label: '任务明细Id',
            prop: 'taskListId',
            hide: true,
          },
          {
            label: '异常描述',
            prop: 'errorContent',
            overHidden: true,
          },
          {
            label: '异常地点',
            prop: 'errorAddress',
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: '异常图片',
            prop: 'errorImg',
            type: 'upload',
            span: 24,
            propsHttp: {
              res: 'data',
              url: 'link',
              name: 'originalName',
            },
            //tip: '只能上传不超过5M的文件或图片',
            action: '/api/blade-resource/oss/endpoint/put-file',
            dataType: 'string',
          },
          {
            label: '上报时间',
            prop: 'createTime',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.inspecttaskerror_add, false),
        viewBtn: this.vaildData(this.permission.inspecttaskerror_view, false),
        delBtn: this.vaildData(this.permission.inspecttaskerror_delete, false),
        editBtn: this.vaildData(this.permission.inspecttaskerror_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
